import { matchPath } from "react-router-dom";

import { pageNames } from "@shared/routes/pageNames";
import { config } from "@shared/services/brandConfig";

export function getPageTitle(pathname: string): string {
	const match = Object.values(pageNames).find((page) =>
		matchPath(page.path, pathname),
	);

	return match?.name
		? `${match.name} - ${config.companyName}`
		: config.companyName;
}

export function setPageTitle(
	pathname: string = window.location.pathname,
): void {
	document.title = getPageTitle(pathname);
}
